import { useState, useEffect } from 'react';

export const STATUS_OPTIONS = ['Requested', 'Unreleased', 'Downloading', 'Downloaded', 'Added', "Can't Find", 'Duplicate'];

export const fontFamily = "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Arial, sans-serif";

export const lightTheme = {
  mainColor: '#1976d2',
  bgColor: '#f7f9fb',
  cardBg: '#fff',
  borderColor: '#e3e8ee',
  text: '#222',
  subtext: '#444',
  tableHeader: '#f7f9fb',
  successBg: '#e8f5e9',
  successText: '#388e3c',
  errorBg: '#ffebee',
  errorText: '#d32f2f',
  shadow: '0 4px 32px 0 rgba(60,72,88,0.08)',
  inputBg: '#fff',
  buttonText: '#fff',
  buttonBg: '#1976d2',
  buttonHoverBg: '#115293',
  deleteBg: '#d32f2f',
  deleteHoverBg: '#b71c1c',
  tableRowBg: '#fff',
  tableRowAltBg: '#f7f9fb',
  footer: '#aaa',
};
export const darkTheme = {
  mainColor: '#90caf9',
  bgColor: '#181c24',
  cardBg: '#232936',
  borderColor: '#2c3442',
  text: '#e3e8ee',
  subtext: '#b0b8c1',
  tableHeader: '#232936',
  successBg: '#244b2f',
  successText: '#81c784',
  errorBg: '#3a2323',
  errorText: '#ef9a9a',
  shadow: '0 4px 32px 0 rgba(0,0,0,0.25)',
  inputBg: '#232936',
  buttonText: '#fff',
  buttonBg: '#1976d2',
  buttonHoverBg: '#1565c0',
  deleteBg: '#d32f2f',
  deleteHoverBg: '#b71c1c',
  tableRowBg: '#232936',
  tableRowAltBg: '#181c24',
  footer: '#555',
};

export function useTheme() {
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');
  const theme = darkMode ? darkTheme : lightTheme;
  useEffect(() => {
    document.body.style.background = theme.bgColor;
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode, theme.bgColor]);
  return { theme, darkMode, toggleDarkMode: () => setDarkMode((d) => !d) };
}

export function ThemeButton({ theme, darkMode, toggleDarkMode }) {
  return (
    <button onClick={toggleDarkMode} title="Toggle dark mode" style={{ background: theme.cardBg, color: theme.text, border: `1.5px solid ${theme.borderColor}`, borderRadius: 6, padding: '8px 18px', fontWeight: 600, fontSize: 15, cursor: 'pointer', marginLeft: 16, boxShadow: '0 2px 8px 0 rgba(60,72,88,0.06)' }}>
      {darkMode ? '🌙 Dark' : '☀️ Light'}
    </button>
  );
}

export function getThStyle(theme) {
  return {
    padding: '10px 8px',
    fontWeight: 700,
    color: theme.mainColor,
    background: theme.tableHeader,
    borderBottom: `2px solid ${theme.borderColor}`,
    textAlign: 'left',
  };
}
export function getTdStyle(theme) {
  return {
    padding: '8px 8px',
    color: theme.text,
    background: 'inherit',
    verticalAlign: 'top',
  };
}
